export default function () {
  return [
    {
      type: 'RemoteSelect',
      title: '家庭关系',
      [$field]: 'familyTies',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'BOE73',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX03'
        }
      },
      rules: ['required']
    },
    {
      type: 'Input',
      title: '姓名',
      [$field]: 'memberName',
      rules: ['required']
    },
    {
      type: 'RemoteSelect',
      title: '性别',
      [$field]: 'memberSex',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'DM14',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['required']
    },
    {
      type: 'DatePicker',
      title: '出生日期',
      [$field]: 'birthday',
      rules: ['']
    },
    {
      type: 'Number',
      title: '年龄',
      [$field]: 'memberAge',
      readOnly: true,
      props: {
        min: 0
      },
      rules: ['']
    },
    // {
    //   type: 'Input',
    //   title: '身份证号',
    //   [$field]: 'idCardNum',
    //   rules: ['']
    // },
    {
      type: 'RemoteSelect',
      title: '民族',
      [$field]: 'nation',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'DM15',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    },
    // {
    //   type: 'SelectTree',
    //   title: '文化程度',
    //   [$field]: 'education',
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'DM16',
    //       merge: false,
    //       bizLineCode: this.bizLineCode || 'YWX01'
    //     }
    //   },
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '政治面貌',
    //   props: {
    //     url: 'api-general/module/portal/user/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'GB4762',
    //       merge: false,
    //       bizLineCode: this.bizLineCode || 'YWX01'
    //     }
    //   },
    //   [$field]: 'political',
    //   rules: ['']
    // },
    // {
    //   type: 'Input',
    //   title: '工作单位或学校',
    //   [$field]: 'workUnit',
    //   rules: ['']
    // },
    {
      type: 'Number',
      title: '月平均收入',
      [$field]: 'monthAvgIncome',
      props: {
        min: 0
      },
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '健康状况',
      [$field]: 'familyMemberHealthy',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'DM33',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    }
    // {
    //   type: 'Input',
    //   title: '联系电话',
    //   [$field]: 'phone',
    //   rules: ['']
    // }
  ]
}